import { Box, Flex, theme } from '@energiebespaarders/symbols';
import { FacebookLogo, InstagramLogo, LinkedinLogo, XLogo } from '@phosphor-icons/react';
import type { IconWeight } from '@phosphor-icons/react';

interface SocialLinksProps {
  justifyContent?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  weight?: IconWeight;
  width?: number;
}

const SocialLinks: React.FC<SocialLinksProps> = ({
  justifyContent = 'center',
  weight = 'regular',
  width = 18,
}) => {
  return (
    <Flex mx={-1} mt={1} justifyContent={justifyContent}>
      <Box px={1}>
        <a
          href="https://fb.com/energiebespaarders"
          className="image-link"
          rel="noopener noreferrer"
          target="_blank"
          title="Energiebespaarders op Facebook"
        >
          <FacebookLogo width={width} weight={weight} color={theme.colors.social.facebook} />
        </a>
      </Box>
      <Box px={1}>
        <a
          href="https://instagram.com/energiebespaarders"
          className="image-link"
          rel="noopener noreferrer"
          target="_blank"
          title="Energiebespaarders op Instagram"
        >
          <InstagramLogo width={width} weight={weight} style={{ fill: 'url(#insta-gradient)' }}>
            <radialGradient id="insta-gradient" r="150%" cx="30%" cy="107%">
              <stop stopColor="#fdf497" offset="0" />
              <stop stopColor="#fdf497" offset="0.05" />
              <stop stopColor="#fd5949" offset="0.45" />
              <stop stopColor="#d6249f" offset="0.6" />
              <stop stopColor="#285AEB" offset="0.9" />
            </radialGradient>
          </InstagramLogo>
        </a>
      </Box>
      <Box px={1}>
        <a
          href="https://www.linkedin.com/company/de-energiebespaarders"
          className="image-link"
          rel="noopener noreferrer"
          target="_blank"
          title="Energiebespaarders op LinkedIn"
        >
          <LinkedinLogo width={width} weight={weight} color={theme.colors.social.linkedIn} />
        </a>
      </Box>
      <Box px={1}>
        <a
          href="https://twitter.com/ebespaarders"
          className="image-link"
          rel="noopener noreferrer"
          target="_blank"
          title="Energiebespaarders op X (voorheen Twitter)"
        >
          <XLogo width={width} weight={weight} color="black" />
        </a>
      </Box>
    </Flex>
  );
};

export default SocialLinks;
